// /**
//  * Created by piotr.pozniak@thebeaverhead.com on 13/10/2018.
//  */

// import React from "react";
//import { createBrowserHistory } from "history";
import { createBrowserHistory } from "history";
import { REHYDRATE } from "redux-persist";

//import { applyMiddleware, createStore } from "redux";
import { applyMiddleware, compose, createStore } from "redux";

import { createTransform, persistReducer, persistStore } from "redux-persist";
import thunk from "redux-thunk";
import logger from "redux-logger";
//import whyDidYouRender from "@welldone-software/why-did-you-render/dist/no-classes-transpile/umd/whyDidYouRender.min.js";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web
import createRootReducer from "./reducers";
import EventsMiddleware from "../../middleware/events";
import CalendarBuilderMiddleware from "../../middleware/CalendarBuilderMiddleware";
import CalendarsMiddleware from "../../middleware/calendars";
import AlertsMiddleware from "../../middleware/alerts";
import AlertsBuilderMiddleware from "../../middleware/AlertsBuilderMiddleware";
import WidgetsMiddleware from "../../middleware/widgets";
import WidgetBuilderMiddleware from "../../middleware/WidgetBuilderMiddleware";
import WidgetItemsCacheMiddleware from "../../middleware/widgetItemsCache";
import IntegrationFiltersMiddleware from "../../middleware/integrationFilters";
import QuotasMiddleware from "../../middleware/quotas";
// import {filtersReducerTransform} from "./reducers/filtersReducer";

const userPersistTransform = createTransform(
  (inboundState) => ({
    model: inboundState.model,
    token: inboundState.token,
    pluginRedirectUrl: inboundState.pluginRedirectUrl,
  }),
  (outboundState) => outboundState,
  { whitelist: ["user"] }
);

const currentOrganizationPersistTransform = createTransform(
  (inboundState) => ({
    model: inboundState.model,
    subscription: inboundState.subscription,
    credits: inboundState.credits,
    subscriptionCredits: inboundState.subscriptionCredits,
    billing: inboundState.billing,
  }),
  (outboundState) => outboundState,
  { whitelist: ["currentOrganization"] }
);

const persistConfig = {
  key: "root",
  storage,
  whitelist: [
    "user",
    "autologin",
    "currentOrganization",
    "dismissedAlerts",
    "appTags",
    "sortableTables",
  ],
  transforms: [userPersistTransform, currentOrganizationPersistTransform],
};

export const history = createBrowserHistory();

const persistedReducer = persistReducer(
  persistConfig,
  createRootReducer(history)
);
const middlewareComponents = [
  thunk,
  EventsMiddleware,
  CalendarBuilderMiddleware,
  CalendarsMiddleware,
  AlertsMiddleware,
  AlertsBuilderMiddleware,
  WidgetsMiddleware,
  // WidgetBuilderMiddleware(signupDefinitions),
  // SignupItemsMiddleware,
  WidgetItemsCacheMiddleware,
  IntegrationFiltersMiddleware,
  QuotasMiddleware,
];

if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
  middlewareComponents.push(logger);
  //whyDidYouRender(React);
}
const middleware = applyMiddleware(...middlewareComponents);

function configureStore(preloadedState) {
  const store = createStore(
    persistedReducer,
    preloadedState,
    compose(middleware)
  );

  return store;
}

export const store = configureStore();
export const persistor = persistStore(store);

export function rehydrateFromStorage() {
  try {
    const serialized = localStorage.getItem("persist:root");
    if (!serialized) return;

    const persistedState = JSON.parse(serialized);

    const parsedState = Object.fromEntries(
      Object.entries(persistedState).map(([k, v]) => [k, JSON.parse(v)])
    );

    store.dispatch({
      type: REHYDRATE,
      key: "root",
      payload: parsedState,
    });
  } catch (err) {
    console.error("Rehydrate failed:", err);
  }
}
